<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.timeDimension">
                    <el-option
                      v-for="(item, index) in timeTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </template>
              <el-date-picker
                v-model="queryDateTime"
                :end-placeholder="$t('operationCenter.endDate')"
                :picker-options="pickerOptions"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <!-- 客户多选（仅已配置客户） -->
          <el-col :span="8">
            <el-form-item :label="$t('tablePrice.customerName')">
              <el-select
                v-model="queryForm.params.customerKeys"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="btnSearch(1)"
              >
                {{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="btnSearch(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button size="small" @click="allExportOrder">{{ $t('newOrder.export') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column :label="$t('tablePrice.customerName')" min-width="180" prop="customerName" />
      <el-table-column
        :label="$t('tablePrice.deliveryQuantity')" min-width="120" prop="signedCount"
        :formatter="thousandFormat"
      />
      <el-table-column
        :label="$t('tablePrice.falseDeliveryQuantity')" min-width="120" prop="falseSignCount"
        :formatter="thousandFormat"
      />
      <el-table-column :label="$t('tablePrice.falseDeliveryRate')" min-width="150" prop="falseSignRate" />
      <el-table-column
        :label="$t('tablePrice.workOrderCreateCount')" min-width="120" prop="workOrderCreateCount"
        :formatter="thousandFormat"
      />
      <el-table-column :label="$t('tablePrice.workOrderCreateRate')" min-width="150" prop="workOrderCreateRate" />
      <el-table-column :label="$t('tablePrice.falseSignEstablishedRate')" min-width="170" prop="falseSignEstablishedRate" />
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTableData"
        @size-change="getSizeTableData"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {
  failSignReportExport,
  falseSignDailyReportSitePage,
  falseSignDailyReportSiteSummary,
  getCustomerConfig
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import { formatNumber } from '@/utils/tools';

export default {
  name: 'FalseSignCustomer',
  data() {
    return {
      // 时间维度：默认签收时间(2)，可切换闭环时间(0)/截止时间(1)
      timeTypeList: [
        { label: this.$t('collectionCenter.signT'), value: 2 },
        { label: this.$t('collectionCenter.closeTime'), value: 0 },
        { label: this.$t('GlobalSetObj.Deadline'), value: 1 }
      ],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          type: 2,
          timeDimension: 2,
          customerKeys: []
        }
      },
      total: 0,
      tableData: [],
      customerOptions: [],
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      choiceDate0: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const d = new Date();
          d.setHours(0, 0, 0, 0);
          d.setDate(d.getDate() + 1);
          const newDate = d.getTime();
          const max = newDate < maxTime ? newDate : maxTime;
          if (this.choiceDate0) {
            return time.getTime() < minTime || time.getTime() > max;
          }
          return time.getTime() > newDate;
        }
      }
    };
  },
  created() {
    this.loadConfig();
    this.getSearch(1);
  },
  methods: {
    // 千分位格式化（整数；中文 1,000 / 葡语 1.000），与网点/大区维度量列一致
    thousandFormat(_row, _column, cellValue) {
      return formatNumber(cellValue, 0);
    },
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    // 取当前用户生效的客户配置（用于客户多选下拉）
    loadConfig() {
      getCustomerConfig().then((res) => {
        if (res.code === 200) {
          this.customerOptions = (res.data || []).filter((i) => i.customerId != null);
        }
      });
    },
    btnSearch(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearch();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: { type: 2, timeDimension: 2, customerKeys: [] }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        this.getSearch();
      }
    },
    buildData() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 2,
          timeDimension: this.queryForm.params.timeDimension,
          customerKeys: this.queryForm.params.customerKeys,
          startTime: '',
          endTime: ''
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return null;
      }
      return data;
    },
    getSearch(val) {
      const data = this.buildData();
      if (!data) return;
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      falseSignDailyReportSitePage(data)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records || [];
            // 合计行置顶
            falseSignDailyReportSiteSummary(data.params).then((s) => {
              if (s.code === 200 && s.data) {
                this.tableData.unshift(s.data);
              }
            });
          }
          if (val === 1 && loading) loading.close();
        })
        .catch(() => {
          if (val === 1 && loading) loading.close();
        });
    },
    allExportOrder() {
      const data = this.buildData();
      if (!data) return;
      data.pageNumber = 1;
      data.pageSize = 5000;
      failSignReportExport(data).then((res) => {
        if (res.code === 200) goResourceTaskList();
      });
    },
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}
.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}
</style>
